var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAlertInfo = function SvgAlertInfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#191F2E",
    d: "M10 18.75a8.75 8.75 0 1 1 0-17.5 8.75 8.75 0 0 1 0 17.5M10 20c5.523 0 10-4.477 10-10S15.523 0 10 0 0 4.477 0 10s4.477 10 10 10"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#191F2E",
    d: "M11.163 8.235 8.3 8.594l-.103.476.564.102c.366.088.44.22.359.586l-.923 4.336c-.242 1.12.132 1.648 1.01 1.648.682 0 1.473-.315 1.832-.747l.11-.52c-.25.22-.615.308-.857.308-.344 0-.469-.242-.381-.667zM11.25 5.625a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0"
  })));
};
export default SvgAlertInfo;